export type HazardValue =
  | "Wind"
  | "Snow or Ice"
  | "Thunderstorm"
  | "Fog"
  | "High Temperature"
  | "Low Temperature"
  | "Coastal Event"
  | "Forest Fire"
  | "Avalanche"
  | "Rain"
  | "Flood"
  | "Rain Flood";

export type HazardAbbr = "Wi" | "SI" | "TS" | "Fo" | "HT" | "LT" | "CE" | "FF" | "Av" | "Ra" | "Fl" | "RF";

export const HAZARD_TYPES: ReadonlyArray<{ value: HazardValue; abbr: HazardAbbr }> = [
  { value: "Wind", abbr: "Wi" },
  { value: "Snow or Ice", abbr: "SI" },
  { value: "Thunderstorm", abbr: "TS" },
  { value: "Fog", abbr: "Fo" },
  { value: "High Temperature", abbr: "HT" },
  { value: "Low Temperature", abbr: "LT" },
  { value: "Coastal Event", abbr: "CE" },
  { value: "Forest Fire", abbr: "FF" },
  { value: "Avalanche", abbr: "Av" },
  { value: "Rain", abbr: "Ra" },
  { value: "Flood", abbr: "Fl" },
  { value: "Rain Flood", abbr: "RF" },
];

/**
 * Mapbox filter expression for NWA type / hazard_code.
 * - Accepts long or abbreviated inputs (case-insensitive)
 * - Uses 'downcase' for comparison
 */
export function buildNwaTypeFilterExpression(codes: string[] | null) {
  if (!codes || codes.length === 0) {
    return null;
  }

  // normalize: lowercase, trim
  const normalized = codes.map((c) => String(c).trim().toLowerCase());

  return [
    "any",
    ["in", ["downcase", ["coalesce", ["get", "type"], ""]], ["literal", normalized]],
    ["in", ["downcase", ["coalesce", ["get", "hazard_code"], ""]], ["literal", normalized]],
  ] as const;
}
